import type { AssetBalanceDto } from '@shared/api/contracts';
import { getAutoWithdrawalPairKey } from '@entities/withdrawal';

export const normalizeBalanceNetworkCode = (network: string): string =>
  network.trim().toUpperCase().replace(/-/g, '');

export const getPairBalanceAmount = (
  assetBalances: AssetBalanceDto[] | undefined,
  assetCode: string,
  networkCode: string,
): string => {
  const pairKey = getAutoWithdrawalPairKey(assetCode, networkCode);
  const normalizedNetwork = normalizeBalanceNetworkCode(networkCode);

  const match = (assetBalances ?? []).find((balance) => {
    if (balance.assetCode !== assetCode) return false;
    const balanceNetwork = normalizeBalanceNetworkCode(balance.network);
    if (balanceNetwork === 'UNALLOCATED') return false;
    return getAutoWithdrawalPairKey(balance.assetCode, balanceNetwork) === pairKey
      || balanceNetwork === normalizedNetwork;
  });

  if (match?.availableAmount != null && match.availableAmount !== '') return match.availableAmount;
  return match?.amount ?? '0';
};
